import { useState, useEffect, useCallback } from 'react'

export const useDynamicHeight = () => {
  const [refsArray, setRefsArray] = useState<HTMLDivElement[]>([])
  const [listHeight, setListHeight] = useState<number>(window.innerHeight)
  const [resizeTimer, setResizeTimer] = useState<NodeJS.Timeout | null>(null)

  const updateHeight = useCallback(() => {
    const totalHeight = refsArray.reduce((acc, current) => acc + current.offsetHeight, 0)
    let calculatedHeight = window.innerHeight - totalHeight
    if (calculatedHeight < 50) {
      calculatedHeight = 500
    }
    setListHeight(calculatedHeight)
  }, [refsArray])

  useEffect(() => {
    const handleResize = () => {
      if (resizeTimer) clearTimeout(resizeTimer)
      setResizeTimer(
        setTimeout(() => {
          updateHeight()
        }, 300)
      ) // Debounce resize events by 300ms
    }

    updateHeight() // Initial calculation
    window.addEventListener('resize', handleResize) // Add debounced resize listener

    return () => {
      window.removeEventListener('resize', handleResize) // Cleanup
      if (resizeTimer) clearTimeout(resizeTimer)
    }
  }, [updateHeight, resizeTimer])

  const addToRefsArray = useCallback(
    (el: HTMLDivElement) => {
      if (el && !refsArray.includes(el)) {
        setRefsArray((prevState) => [...prevState, el])
      }
    },
    [refsArray]
  )

  return { addToRefsArray, listHeight }
}
